// extracted by mini-css-extract-plugin
export var createdDate = "_lk-1";
export var divider = "_lk-2";
export var headerDivider = "_lk-3";
export var messagesCard = "_lk-0";
export var messagesContainer = "_lk-6";
export var messagesContainerWrapper = "_lk-4";
export var showLeftPanelButton = "_lk-8";
export var topButtons = "_lk-7";
export var withPadding = "_lk-5";